import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const items = [{
  icon: '🗓️',
  title: 'Weekend rubati',
  desc: 'Sei stanco di passare il sabato a disegnare schemi elettrici o scrivere programmi da zero per i tuoi corsi tecnici.'
}, {
  icon: '😓',
  title: 'Energia a zero',
  desc: "Arrivi a casa esausto dopo il cantiere o l'aula e devi ancora preparare la lezione per il giorno dopo."
}, {
  icon: '📡',
  title: 'Aggiornamento impossibile',
  desc: 'Senti che la tecnologia corre più veloce dei tuoi materiali: Matter, Thread, AI applicata al BAS. Non vuoi fare brutta figura davanti agli allievi.'
}, {
  icon: '🏆',
  title: 'Vuoi fare la differenza',
  desc: 'Vuoi presentare alla direzione scolastica o ai tuoi clienti un programma tecnico serio, strutturato e di prestigio europeo.'
}];
export function ForYouChecklist() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-card/50 border-y border-brand-orange/10 relative" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-125">
          Ti riconosci?
        </p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-3 text-brand-cream" data-id="element-126">
          Questa risorsa è per te se...
        </motion.h2>
        <p className="text-center text-gray-400 text-sm mb-10" data-id="element-127">
          Se ti riconosci in 2 o più di queste situazioni, sei nel posto giusto.
        </p>

        <div className="space-y-4" data-id="element-128">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex gap-4 items-start bg-brand-dark p-5 rounded-xl border border-white/5 hover:border-brand-orange/30 transition-colors" data-id="element-129">
              <span className="text-2xl shrink-0" data-id="element-130">{item.icon}</span>
              <div data-id="element-131">
                <h3 className="text-base sm:text-lg font-bold text-brand-cream mb-1" data-id="element-132">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-400 font-medium leading-relaxed" data-id="element-133">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center mt-8 text-brand-gold font-bold text-base sm:text-lg mb-6" data-id="element-134">
          ✓ Allora Sistema Domotica Pro è stato creato esattamente per te.
        </p>

        <CTAButton className="max-w-md mx-auto" data-id="element-135">
          VOGLIO INSEGNARE CON AUTORITÀ — ACCEDI ORA
        </CTAButton>
      </div>
    </section>;
}